/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Attr_Share_Common_Area_DenominatorInputs */

const cs_sreality_attr_share_common_area_denominator = /** @type {(inputs: Sreality_Attr_Share_Common_Area_DenominatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podíl na společných částech — jmenovatel`)
};

const en_sreality_attr_share_common_area_denominator = /** @type {(inputs: Sreality_Attr_Share_Common_Area_DenominatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share of common areas — denominator`)
};

/**
* | output |
* | --- |
* | "Share of common areas — denominator" |
*
* @param {Sreality_Attr_Share_Common_Area_DenominatorInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_attr_share_common_area_denominator = /** @type {((inputs?: Sreality_Attr_Share_Common_Area_DenominatorInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Attr_Share_Common_Area_DenominatorInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_attr_share_common_area_denominator(inputs)
	return cs_sreality_attr_share_common_area_denominator(inputs)
});